// Libs
import { useMemo } from 'react';

// Hooks
import useProduct from '@/common/hooks/products/useProduct';

const useProductModal = ({ path }) => {
  const {
    data: product,
    isLoading: isLoadingProduct,
    isFetching: isFetchingProduct,
    isError: isErrorProduct,
    isSuccess: isSuccessProduct,
  } = useProduct(path);

  const isDisabled = useMemo(() => {
    const loading = isLoadingProduct || isFetchingProduct;

    return {
      disabled: loading,
      loading,
    };
  }, [isFetchingProduct, isLoadingProduct]);

  const lengthName = useMemo(() => product?.name.length > 100, [product]);

  const getSlider = useMemo(() => product?.slider.data.filter((item) => item), [
    product,
  ]);

  return {
    getSlider,
    isDisabled,
    isError: isErrorProduct,
    isSuccess: isSuccessProduct,
    lengthName,
    product,
  };
};

export default useProductModal;
